import { actions } from '@pages/Main/Timetable/actionsEnum';
import TYPES from './TYPES';
import { dynamicImport } from '@/helpers/new/dynamicImport';
import SelectionCourseBlocks from './Journal/SelectionCourseBlocks';
import JournalLessonTypeInfo from './Journal/JournalLessonTypeInfo';

const IntersectionCheck = dynamicImport(() => import('./Timetable/IntersectionCheck'));
const AddVideoLesson = dynamicImport(() => import('./AddVideoLesson'));
const RemoveVideoLesson = dynamicImport(() => import('./RemoveVideoLesson'));
const BulkUpload = dynamicImport(() => import('./BulkUpload'));
const AddLessonOrMeeting = dynamicImport(() => import('./Timetable/AddLessonOrMeeting'));
const JournalDownloadExcel = dynamicImport(() => import('./Journal/JournalDownloadExcel'));
const JournalAddField = dynamicImport(() => import('./Journal/JournalAddField'));
const EditLessonOrMeeting = dynamicImport(() => import('./Timetable/EditLessonOrMeeting'));
const AudienceForm = dynamicImport(() => import('./Timetable/AudienceForm'));
const AudienceReplace = dynamicImport(() => import('./Timetable/AudienceReplace'));
const ShowLessonOrMeeting = dynamicImport(() => import('./Timetable/ShowLessonOrMeeting'));
const JournalAddColumn = dynamicImport(() => import('./Journal/JournalAddColumn'));
const JournalAutoFillAdditionalField = dynamicImport(
    () => import('./Journal/JournalAutoFillAdditionalField')
);
const Confirmation = dynamicImport(() => import('./Confirmation'));
const CopyMaterial = dynamicImport(() => import('./EditDirection/CopyMaterial'));
const ResizeImage = dynamicImport(() => import('./tiptap/ResizeImage'));
const DepartmentsSelect = dynamicImport(() => import('./DepartmentsSelect'));
const UploadMediaModal = dynamicImport(
  () => import('./PlatformMedia/UploadMediaModal/UploadMediaModal'),
  'UploadMediaModal',
);
const SelectFilesFromMediaPlatform = dynamicImport(
  () => import('./PlatformMedia/SelectFilesFromMediaPlatform/SelectFilesFromMediaPlatform'),
  'SelectFilesFromMediaPlatform',
);
const AddingToPlanningTable = dynamicImport(() => import('./Timetable/AddingToPlanningTable'));
const ChangeDeadline = dynamicImport(() => import('./Homework/ChangeDeadline'));
const RegisterLesson = dynamicImport(() => import('./Timetable/RegisterLesson'));
const CreateWelcomeMessage = dynamicImport(() => import('./Chat/CreateWelcomeMessage'));
const AdditionalColumn = dynamicImport(() => import('./PlatformSettings/AdditionalColumn'));
const JournalTestAnalyticsSettings = dynamicImport(() => import('./Journal/JournalTestAnalyticsSettings'));
const DelayedMessage = dynamicImport(() => import('./Chat/DelayedMessage'));
const ChatFolders = dynamicImport(() => import('./Chat/ChatFolders'));
const AddFieldFinalAnalytics = dynamicImport(() => import('./Journal/JournalAddField/AddFieldFinalAnalytics'));
const JournalDownloadSettings = dynamicImport(() => import('./Journal/JournalDownloadSettings'));
const ListOfPersonalAccounts = dynamicImport(() => import('./ListOfPersonalAccounts'));
const ManualsModal = dynamicImport(() => import('./ManualsModal/ManualsModal'));
const ReportsVisibilityModal = dynamicImport(() => import('./ReportsVisibility/ReportsVisibilityModal'));
const ViewImage = dynamicImport(() => import('./ViewImage'));
const AddGroups = dynamicImport(() => import('./Timetable/AddGroups'));
const DownloadImageWithCustomTitle = dynamicImport(() => import('./Timetable/DownloadImageWithCustomTitle'));
const AiTaskGenerator = dynamicImport(() => import('./AiTaskGenerator'));
const AiCourseStructureModal = dynamicImport(() => import('./AiCourseStructureModal'));
const ActivityAnalyticsSettings = dynamicImport(() => import('./Reports/ActivityAnalyticsSettings'));
const GroupGradingSystem = dynamicImport(() => import('./GroupGradingSystem'));
const SelectGradingSystem = dynamicImport(() => import('./SelectGradingSystem'));

const modalsList = [
    {
        name: 'addVideoLesson',
        component: AddVideoLesson
    },
    {
        name: 'removeVideoLesson',
        component: RemoveVideoLesson
    },
    {
        name: 'bulkUpload',
        component: BulkUpload
    },
    {
        name: actions.addLessonOrMeeting,
        component: AddLessonOrMeeting
    },
    {
        name: actions.intersectionCheck,
        component: IntersectionCheck
    },
    {
        name: actions.registerLesson,
        component: RegisterLesson
    },
    {
        name: actions.addGroups,
        component: AddGroups
    },
    {
        name: actions.downloadImageWithCustomTitle,
        component: DownloadImageWithCustomTitle
    },
    {
        name: TYPES.JOURNAL_ADD_FIELD,
        component: JournalAddField
    },
    {
        name: TYPES.JOURNAL_ADD_COLUMN,
        component: JournalAddColumn
    },
    {
        name: TYPES.JOURNAL_AUTO_FILL_ADDITIONAL_FIELD,
        component: JournalAutoFillAdditionalField
    },
    {
        name: TYPES.JOURNAL_DOWNLOAD_EXCEL,
        component: JournalDownloadExcel
    },
    {
        name: TYPES.JOURNAL_DOWNLOAD_SETTINGS,
        component: JournalDownloadSettings
    },
    {
        name: TYPES.JOURNAL_TEST_ANALYTICS_SETTINGS,
        component: JournalTestAnalyticsSettings
    },
    {
        name: TYPES.JOURNAL_ADD_FIELD_FINAL_ANALYTICS,
        component: AddFieldFinalAnalytics
    },
    {
        name: TYPES.JOURNAL_LESSON_TYPE_INFO,
        component: JournalLessonTypeInfo
    },
    {
        name: actions.showLessonOrMeeting,
        component: ShowLessonOrMeeting
    },
    {
        name: actions.editLessonOrMeeting,
        component: EditLessonOrMeeting
    },
    {
        name: TYPES.TIMETABLE_AUDIENCE_FORM,
        component: AudienceForm
    },
    {
        name: TYPES.TIMETABLE_AUDIENCE_REPLACE,
        component: AudienceReplace
    },
    {
        name: actions.addingToPlanningTable,
        component: AddingToPlanningTable
    },
    {
        name: TYPES.CONFIRMATION,
        component: Confirmation
    },
    {
        name: TYPES.UPLOADING_FILES_TO_MEDIA_PLATFORMS,
        component: UploadMediaModal
    },
    {
        name: TYPES.EDIT_DIRECTION_COPY,
        component: CopyMaterial
    },
    {
        name: TYPES.TIPTAP_RESIZE_IMAGE,
        component: ResizeImage
    },
    {
        name: TYPES.DEPARTMENTS_SELECT,
        component: DepartmentsSelect
    },
    {
        name: TYPES.SELECT_FILES_FROM_MEDIA_PLATFORM,
        component: SelectFilesFromMediaPlatform
    },
    {
        name: TYPES.CHANGE_DEADLINE,
        component: ChangeDeadline
    },
    {
        name: TYPES.CREATE_WELCOME_MESSAGE,
        component: CreateWelcomeMessage
    },
    {
        name: TYPES.DELAYED_MESSAGE,
        component: DelayedMessage
    },
    {
        name: TYPES.CHAT_FOLDERS,
        component: ChatFolders
    },
    {
        name: TYPES.PLATF_SETTINGS_ADDITIONAL_COLUMN,
        component: AdditionalColumn
    },
    {
        name: TYPES.LIST_OF_PERSONAL_ACCOUNTS,
        component: ListOfPersonalAccounts
    },
    {
      name: TYPES.MANUALS_MODAL,
      component: ManualsModal,
    },
    {
      name: TYPES.REPORTS_VISIBILITY,
      component: ReportsVisibilityModal,
    },
    {
      name: TYPES.VIEW_IMAGE,
      component: ViewImage,
    },
    {
          name: TYPES.AI_TASK_GENERATOR,
          component: AiTaskGenerator,
    },
    {
      name: TYPES.AI_COURSE_STRUCTURE_GENERATOR,
      component: AiCourseStructureModal,
    },
    {
      name: TYPES.SELECTION_COURSE_BLOCKS,
      component: SelectionCourseBlocks,
    },
    {
      name: TYPES.ACTIVITY_ANALYTICS_SETTINGS,
      component: ActivityAnalyticsSettings,
    },
    {
      name: TYPES.GROUP_GRADING_SYSTEM,
      component: GroupGradingSystem,
    },
    {
      name: TYPES.SELECT_GRADING_SYSTEM,
      component: SelectGradingSystem,
    },
];

export default modalsList
